import React from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../../decorators'
import RS from '../../../../../lib/IssueMapping/ReviewOfSystems'
import { ROSQuestionnaire } from '../../../../../lib/Questionnaires'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import IssueQueuer from '../../../../shared/IssueQueuer'
import { CircularProgress } from '../../../../shared/NarusMaterial'
import * as Actions from '../../lib/new-actions'

import RoS from './form'

const CATEGORY = 'Review of Systems'

class App extends React.Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.resetForm = this.resetForm.bind(this)
  }

  componentDidMount () {
    this.resetForm()
  }

  handleSubmit (data) {
    this.queueIssues(data)
    this.props.dispatch(
      Actions.createAssessment(
        data,
        this.props.params.id,
        this.props.currentUser.id,
        CATEGORY,
        this.props.encounter.document.context_id,
        ROSQuestionnaire
      )
    )
  }

  resetForm () {
    const contextId = this.props.encounter?.document?.context_id

    if (contextId) {
      this.props.dispatch(
        Actions.getAssessment(
          this.props.params.id,
          CATEGORY,
          ROSQuestionnaire,
          contextId
        )
      )
    }
  }

  queueIssues (data) {
    const iq = new IssueQueuer({
      dispatch: this.props.dispatch,
      patientId: this.props.patientId,
      practitionerId: this.props.practitionerId,
      encounterId: this.props.encounter?.id
    })

    iq.queueIssues({
      mapping: RS,
      currentForm: data,
      existingForms: undefined
    })
  }

  render () {
      const formData = this.props.questionnaire?.[CATEGORY]?.formData ?? {}

      const loading = this.props.questionnaire?.[CATEGORY]?.loading

    const ROScontent = (
      <RoS
        formKey='reviewOfSystems'
        onSubmit={this.handleSubmit}
        initialValues={formData}
        cancel={this.resetForm}
      />
    )
    return (
      <div className='main review-of-systems'>
        <Card.Card>
          <Card.Header>
            <h2>Review of Systems</h2>
          </Card.Header>
          {loading ? <CircularProgress /> : ROScontent}
        </Card.Card>
        <IGAO path='review_of_systems' />

      </div>
    )
  }
}

const mapStateToProps = redux => ({
  questionnaire: redux.questionnaire,
  encounter: redux.encounter?.encounter,
  patientId: redux?.globalVars?.params?.id,
  currentUser: redux.users.current_user,
  practitionerId: redux.auth.profile.sub
})

export default connect(mapStateToProps)(withLegacyRouter(App))
